import { RecurringDonation } from "../../types"
import PledgeDetails from "../../planned_giving/PledgeDetails"
import { usePlannedGivingContext } from "../../hooks/usePlannedGivingContext"
import RecurringDonationsList from "../../planned_giving/RecurringDonationsList"

export default function PlannedGivingSummary() {
  const { recurringDonations, pledges, pledgeCampaigns, jointGiver } =
    usePlannedGivingContext()

  const activeRecurringDonations: RecurringDonation[] | [] =
    recurringDonations.length > 0
      ? recurringDonations
          .filter((donation) => donation.on_hold_indefinitely === false)
          .sort(
            (a: RecurringDonation, b: RecurringDonation) =>
              new Date(a?.next_occurrence || 0).getTime() -
              new Date(b?.next_occurrence || 0).getTime(),
          )
      : []

  const currentPledgeCampaigns = pledgeCampaigns.filter(
    (campaign) => new Date(campaign.ends_at) > new Date(),
  )

  const currentPledges = pledges.filter((pledge) =>
    currentPledgeCampaigns.some(
      (campaign) => campaign.id === pledge.pledge_campaign.id,
    ),
  )

  return (
    <>
      <div className="d-f fd-c g-1">
        <span className="fw-600 fs-13 c-tint2 tt-u">
          Next recurring donation
        </span>
        <RecurringDonationsList
          recurringDonations={activeRecurringDonations}
          showFullDetails={false}
        />
      </div>
      {currentPledges.length > 0 && (
        <div className="d-f fd-c g-1">
          <span className="fw-600 fs-13 c-tint2 tt-u">Current pledges</span>
          {currentPledges.map((pledge) => (
            <PledgeDetails
              jointGiver={jointGiver}
              key={pledge.id}
              pledge={pledge}
              pledgeCampaign={pledge.pledge_campaign}
              fund={pledge.fund}
              showFullDetails={false}
            />
          ))}
        </div>
      )}
    </>
  )
}
